// Initial state for cost of attendance
export const initialCostOfAttendance = [
  {
    type: "Tuition & Fees",
    lastYear: 0,
    currentYear: 0,
    percentChange: 0,
  },
  {
    type: "Cost of Attendance",
    lastYear: 0,
    currentYear: 0,
    percentChange: 0,
  },
];

// Helper function to calculate percentage change
const calculatePercentChange = (current, previous) => {
  if (!previous || previous === "No Base Value") return "No Base Value";
  return (current - previous) / previous;
};

// Helper function to update a specific item
const updateItem = (state, tuition, coa, field) => {
  state.forEach((item) => {
    if (item.type === "Tuition & Fees") {
      item[field] = tuition;
      item.percentChange = calculatePercentChange(
        item.currentYear,
        item.lastYear
      );
    } else {
      item[field] = coa;
      item.percentChange = calculatePercentChange(
        item.currentYear,
        item.lastYear
      );
    }
  });
  return state;
};

// Reducer function
export const costOfAttendanceReducer = (state, action) => {
  switch (action.type) {
    case "update_last_year":
      return updateItem(state, action.tuition, action.coa, "lastYear");

    case "update_current_year":
      return updateItem(state, action.tuition, action.coa, "currentYear");

    default:
      console.warn(`Unknown action type: ${action.type}`);
      return state;
  }
};
